import masonPic from "@/public/images/artists/mason.png";
import { Artist } from "@/types/types";

export const mason = {
  id: "21",
  name: "Mason",
  image: masonPic,
  description: `Meet "Mason," the male pop singer with a voice that radiates vulnerability. From heartfelt ballads to soul-searching melodies, Mason's music captures the essence authenticity.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fmason-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Pop"],
      secondary: ["Singer", "Vulnerable", "Emotional", "Intimate"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Low",
      },
      specific: {
        low: 52,
        high: 70,
      },
    },
  },
} as const satisfies Artist;
